export const roundRating = (value: number): number => Math.round(value * 10) / 10
